/** Print sizes for the A5 pawn ticket. Each value is in points. */
const PAWN_TICKET_TYPE = {
  companyName: { fontSize: '20pt', fontWeight: 700 },
  address: { fontSize: '8pt', fontWeight: 400 },
  pawnTicket: { fontSize: '13pt', fontWeight: 700 },
  licenceForm: { fontSize: '7.5pt', fontWeight: 500 },
  ticketDateLabel: { fontSize: '10.5pt', fontWeight: 600 },
  ticketDateValue: { fontSize: '17pt', fontWeight: 700 },
  sectionHeading: { fontSize: '10pt', fontWeight: 700 },
  fieldLabel: { fontSize: '8.5pt', fontWeight: 600 },
  customerName: { fontSize: '11pt', fontWeight: 700 },
  detail: { fontSize: '8.5pt', fontWeight: 400 },
  articleHeading: { fontSize: '7pt', fontWeight: 700 },
  articleValue: { fontSize: '8pt', fontWeight: 400 },
  photoCaption: { fontSize: '7pt', fontWeight: 600 },
  signatureCaption: { fontSize: '7pt', fontWeight: 600 },
  tearOff: { fontSize: '8pt', fontWeight: 400 },
};

export default PAWN_TICKET_TYPE;
